import React, { useEffect, useState } from 'react';
import { Container as MapDiv, NaverMap, Marker } from 'react-naver-maps';
import { Bounds, Store } from '../../types/stores';
import useCurrentStores from '../../hooks/useCurrentStore';
import { debounce } from '@mui/material';
import StoreBottomDrawerSection from '../StoreBottomDrawerSection';
import Loading from '../Loading';
import {
	selectedMarkerIcon,
	unSelectedMarkerIcon,
} from '../../utils/markerIcons';
import BannerDialog from '../BannerDialog/BannerDialog';

const INJE_UNIVERSITY_COORDINATES = { lat: 35.2485, lng: 128.9037 };
const INJE_CCC_CORDINATES = { lat: 35.2507, lng: 128.9025 };

const MapSection = () => {
	const [bounds, setBounds] = useState<Bounds>(null);
	const [selectStore, setSelectStore] = useState(null as Store | null);
	const [drawerOpen, setDrawerOpen] = useState(false);
	const { currentGlobalStores, isLoading, mapRef } = useCurrentStores({
		bounds,
	});

	const handleBoundsChanged = (bounds: any) => {
		if (!bounds) return;
		const { _ne, _sw } = bounds;
		setBounds({
			north: _ne._lat,
			south: _sw._lat,
			east: _ne._lng,
			west: _sw._lng,
		});
	};
	const debouncedHandleBoundsChanged = debounce(handleBoundsChanged, 100);

	const handleMarker = (store: Store) => {
		if (selectStore) {
			setSelectStore(null);
		}
		setSelectStore(store);
		setDrawerOpen(true);
	};

	const dismissMarker = () => {
		setSelectStore(null);
		setDrawerOpen(false);
	};
	return (
		<MapDiv
			style={{
				height: '100%',
				display: 'flex',
				justifyContent: 'center',
				flexDirection: 'column',
				alignItems: 'center',
			}}
		>
			<NaverMap
				defaultCenter={INJE_UNIVERSITY_COORDINATES}
				onBoundsChanged={debouncedHandleBoundsChanged}
				center={INJE_UNIVERSITY_COORDINATES}
				ref={mapRef}
			>
				{selectStore && (
					<Marker
						zIndex={100}
						icon={selectedMarkerIcon(selectStore.type)}
						onClick={dismissMarker}
						position={{
							lat: selectStore.coordinates[0],
							lng: selectStore.coordinates[1],
						}}
					/>
				)}
				<StoreBottomDrawerSection
					isOpen={drawerOpen}
					storeInfo={selectStore as Store}
				/>
				{isLoading ? (
					<Loading></Loading>
				) : (
					<>
						<Marker
							zIndex={99}
							icon={unSelectedMarkerIcon(7)}
							onClick={() =>
								handleMarker({
									id: 'ccc',
									name: '인제 CCC',
									description: '사랑이 넘쳐나는 공동체 | 위치: 늘빛관 401호',
									coordinates: [
										INJE_CCC_CORDINATES.lat,
										INJE_CCC_CORDINATES.lng,
									],
									address: 'string',
									type: 7,
									totalRating: -1,
									link: 'ccc',
									reviewCount: -1,
								} as Store)
							}
							position={INJE_CCC_CORDINATES}
						/>
						{currentGlobalStores &&
							currentGlobalStores.map((store) => (
								<Marker
									key={store.id}
									zIndex={1}
									icon={unSelectedMarkerIcon(store.type)}
									onClick={() => handleMarker(store)}
									position={{
										lat: store.coordinates[0],
										lng: store.coordinates[1],
									}}
								/>
							))}
					</>
				)}
			</NaverMap>
		</MapDiv>
	);
};

export default MapSection;
